module.exports = __webpack_public_path__ + "static/media/image_14.631d9192.png";